import { decode } from 'he';

function fixBackgroundImages(input: string): string {
  const regex = /data-background-images="({[^{}]+})"/g;
  return input.replace(regex, (_, p1: string) => {
    const backgroundImgAttr = decode(p1, {
      isAttributeValue: true
    }).replace(/\\+/g, '');

    return `data-background-images="${btoa(backgroundImgAttr)}"`;
  });
}

export function htmlDecode(input: string): string {
  const replacedInput = fixBackgroundImages(input).replace(/\\r\\n/g, '');

  return decode(replacedInput);
}
